export default {"src":"/_next/static/media/grundriss-grau.b4ba3e37.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};